import { createRouter, createWebHistory } from 'vue-router'
import Chat from '../views/Chat.vue'
import Main from '../views/Main.vue'
import Market from '../views/Market.vue'
import Candlestick from '../views/Candlestick.vue'
import Trend from '../views/Trend.vue'
import Signal from '../views/Signal.vue'
import Resonance from '../views/Resonance.vue'
import Strategy from '../views/Strategy.vue'
import Trade from '../views/Trade.vue'
import Statistic from '../views/Statistic.vue'
import FinancialAnalysis from '../views/FinancialAnalysis.vue'
import Correlation from '../views/Correlation.vue'
import Regression from '../views/Regression.vue'
import History from '../views/History.vue'
import Technical from '../views/Technical.vue'
import Picking from '../views/Picking.vue'
import Hedge from '../views/Hedge.vue'
import Backtest from '../views/Backtest.vue'
import Info from '../views/Info.vue'
import ArticleEditor from '../views/ArticleEditor.vue'
import Me from '../views/Me.vue'
import Margin from '../views/Margin.vue'
import Login from '../views/Login.vue'
import Pay from '../views/Pay.vue'
import Doc from '../views/Doc.vue'
import FinancialMarkets from '../views/doc/FinancialMarkets.vue'
import Investor from '../views/doc/Investor.vue'
// import Trend from '../views/doc/Trend.vue'

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      // {
      //   path: '/',
      //   component: Chat
      // },
      {
        path: '/',
        component: Market
      },
      {
        path: '/market',
        component: Market
      },
      {
        path: '/trade',
        component: Trade
      },
      {
        path: '/candlestick',
        component: Candlestick
      },
      {
        path: '/signal',
        component: Signal
      },
      {
        path: '/trend',
        component: Trend
      },
      {
        path: '/resonance',
        component: Resonance
      },
      {
        path: '/strategy',
        component: Strategy
      },
      {
        path: '/statistic',
        component: Statistic
      },
      {
        path: '/financial_analysis',
        component: FinancialAnalysis
      },
      {
        path: '/technical',
        component: Technical
      },
      {
        path: '/picking',
        component: Picking
      },
      {
        path: '/correlation',
        component: Correlation
      },
      {
        path: '/regression',
        component: Regression
      },
      {
        path: '/hedge',
        component: Hedge
      },
      {
        path: '/history',
        component: History
      },
      {
        path: '/backtest',
        component: Backtest
      },
      {
        path: '/margin',
        component: Margin
      },
      // {
      //   path: '/info',
      //   component: Info
      // },
      // {
      //   path: '/article_editor',
      //   component: ArticleEditor
      // },
      {
        path: '/me',
        component: Me
      },
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/pay',
    component: Pay
  },
  {
    path: '/doc',
    component: Doc,
    children: [
      {
        path: '/doc/investor',
        component: Investor
      },
      {
        path: '/doc/financial_markets',
        component: FinancialMarkets
      },
      // {
      //   path: '/doc/trend',
      //   component: Trend
      // }
    ]
  },
  {
    path: '/:any',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: "/mft_web/",
  routes
})

export default router
